import clsx from "clsx";
import { type ReactNode } from "react";

interface BadgeProps {
  variant?: "default" | "success" | "warning" | "orange";
  children: ReactNode;
  className?: string;
}

export function Badge({
  variant = "default",
  children,
  className,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-body font-bold",
        {
          "bg-beige/20 text-grey": variant === "default",
          "bg-green/10 text-green": variant === "success",
          "bg-yellow-100 text-yellow-800": variant === "warning",
          "bg-orange/10 text-orange": variant === "orange",
        },
        className,
      )}
    >
      {children}
    </span>
  );
}
